import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { AgGridReact } from 'ag-grid-react';
import LoadRowsComponent from '../../helpers/LoadRowsComponent';
import { excelStyles } from '../../components/Grid/ExcelStyles/excelStyles';
import StudyLinkForeignKey from '../../components/Grid/CellRenderer/StudyLinkForeignKey';
import OverrideField from '../../helpers/OverrideField';
import TotalRow from '../../components/Grid/CellRenderer/TotalRow';

const LinksGrid = ({
    linksList,
    search,
    onRowClicked,
    onDeleteClicked,
    setRefresh,
    refresh,
    sort = "",
    setSort = () => {},
    isStudyDetail = false,
}) => {
  // const [rowData, setRowData] = useState(locationsList);
  const [gridApi, setGridApi] = useState(null);
  const [totalRows, setTotalRows] = useState(linksList ? linksList.length : 0);
  useEffect(() => {
    if(linksList){
      setTotalRows(linksList.length)
    }
  }, [linksList]);

  // useEffect(() => {
  //   if(gridApi){
  //     //loads in more rows while scrolling
  //     const dataSource = {
  //       getRows: function(params) {
  //         // console.log(params.request);
  //         let sortParam = "";
  //         if(params.request.sortModel.length !== 0){
  //           const sortColumn = params.request.sortModel[0].colId;
  //           const sortWay = params.request.sortModel[0].sort;
  //           if(sortWay=== "desc"){
  //             sortParam += "-";
  //           }
  //           sortParam += sortColumn;
  //           sortParam = sortParam.replaceAll(".", "__");
  //         }
  //         if(sortParam){
  //           setSort(sortParam);
  //         }
  //         else{
  //           setSort("");
  //         }
  //         const rows = getLocations({limit: 100, offset: params.request.startRow, search: search, sort: sort})
  //         .then( res => {
  //           setTotalRows(res.count);
  //           params.success({
  //             rowData: res.results,
  //             rowCount: res.count
  //           })
  //           if(res.count === 0){
  //             gridApi.showNoRowsOverlay();
  //           }
  //           });
  //       }
        
  //     };
  //     gridApi.setServerSideDatasource(dataSource);
  //   }
  // }, [gridApi, search, sort]);
  
  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const cellClicked = (event) => {
    const { cellRenderer } = event.colDef;
    if (cellRenderer !== "removeRow") {
      onRowClicked(event.data);
    }
  };

  const deleteRow = (itemId) => {
    onDeleteClicked(itemId);
  };

  const onFilterChanged = () => {
    if (gridApi) {
      const displayedRowCount = gridApi.getDisplayedRowCount();
      setTotalRows(displayedRowCount);
    }
  };

  const gridOptions = {
    columnDefs: [
      {
        headerName: 'Button Text',
        field: 'button_text',
        // cellRendererParams: {
        //   source: 'button_text',
        // },
        flex: '1'
      },
      {
        headerName: 'URL',
        field: 'url',
        // cellRendererParams: {
        //   source: 'url',
        // },
        flex: '1'
      },
      {
        headerName: 'Description',
        field: 'description',
        // cellRenderer: 'overrideField',
        // cellRendererParams: {
        //   source: 'country',
        // },
        flex: '1'
      },
      {
        headerName: 'Logo',
        field: 'logo',
        // cellRenderer: 'overrideField',
        // cellRendererParams: {
        //   source: 'country',
        // },
        flex: '1'
      },
      {
        headerName: "",
        width: 40,
        cellRenderer: "removeRow",
      }
    ],
    defaultColDef: {
      resizable: true,
      sortable: true,
      wrapText: true,
      filter: true,
      enablePivot: true,
      enableCharts: false,
      enableRowGroup: true,
      filterParams: {
        clearButton: true
      },
      cellStyle: { "white-space": "normal !important" },
      autoHeight: true,
      cellClassRules: {
        oddBackground: function (params) {
          return params.rowIndex % 2 == 0;
        },
      },
    },
    excelStyles,
    frameworkComponents: {
      removeRow: ({ data }) => {
        // const id = data?.id;
        return (
          <i
            className="fal fa-trash-alt"
            style={{ color: "red" }}
            onClick={() => deleteRow(data)}
          ></i>
        );
      },
      LoadRowsComponent: LoadRowsComponent,
    },
    loadingCellRenderer: 'LoadRowsComponent',
    loadingCellRendererParams :{
      loadingMessage: 'One moment please...',
    },
  };

  return (
    <Container className="ag-theme-balham">
      { isStudyDetail
      ?
      <AgGridReact
        onGridReady={onGridReady}
        gridOptions={gridOptions}
        onCellClicked={event => cellClicked(event)}
        onFilterChanged={onFilterChanged}
        rowData={linksList}
      ></AgGridReact>
      :
      <AgGridReact
      onGridReady={onGridReady}
      gridOptions={gridOptions}
      onCellClicked={event => cellClicked(event)}
      onFilterChanged={onFilterChanged}
      rowModelType={'serverSide'}
      serverSideStoreType={'partial'}
      cacheBlockSize={100}
    ></AgGridReact>
      }
      <TotalRow count={totalRows} />
    </Container>
  );
};

export default LinksGrid;

const Container = styled.div`
flex: 1 1 auto;
padding-bottom: 20px;
`
